export const ENVIRONMENT = {
  url: 'https://preprod-v2-front.gem-connector.com',
  api: {
    url: 'https://preprod-v2-back.gem-connector.com'
  },
  auth0: {
    domain: 'gem-connector.eu.auth0.com',
    clientId: '7QWDPIQMdPg5ecWzOdV5KqheFkFoFRGz',
    authorizationParams: {
      scope: 'read:current_user'
    }
  }
};
